/**
 * Turn an axios error into a string that is always safe to render.
 *
 * FastAPI sends `detail` as a plain string for raised HTTPExceptions but as a _list_ of `{type,
 * loc, msg, input, ctx}` objects for request-validation failures. Passing that list straight into
 * JSX crashes the page with "Objects are not valid as a React child", which hides the very message
 * that would explain the problem.
 */
export const errorMessage = (err, fallback) => {
  const detail = err?.response?.data?.detail;

  if (typeof detail === "string" && detail) return detail;

  if (Array.isArray(detail)) {
    const messages = detail.map((item) => item?.msg).filter(Boolean);
    if (messages.length) return messages.join(". ");
  }

  // A bare object detail is unusual, but stringifying beats crashing.
  if (detail && typeof detail === "object") {
    return detail.msg || detail.message || fallback;
  }

  return err?.message || fallback;
};
